import {
  AccountEnrollment,
  AppAccountResponse,
  Location,
} from "@Light/services/lightTypes";
import { Requirements } from "@Light/services/lightTypes";
import { createContext, useContext } from "react";

export type OnBack = () => void;

// The customer account API always returns an enrollment with its
// `requirements`, both of which the schema marks optional. Encode those
// guarantees on top of the generated account type.
export type Account = AppAccountResponse & {
  enrollment: AccountEnrollment & { requirements: Requirements };
  term_month_options?: number[] | null;
};

export const AccountContext = createContext<Account | undefined>(undefined);

export function useAccount(): Account {
  const account = useContext(AccountContext);
  if (!account) {
    throw new Error("WithAccount provider must be used for useAccount");
  }

  return account;
}

export function useLocation(): Location {
  const account = useAccount();
  const location = account.locations[0];
  if (!location) {
    throw new Error("no location discovered");
  }

  return location;
}
